<ui-base-camera
    [takePhotoBtn]="takePhotoBtn"
    [width]="width"
    [height]="height"
    (onPhotoTaken)="getPhoto($event)"
    *ngIf="!isCaptured"
></ui-base-camera>

<img
    *ngIf="isCaptured"
    [src]="dataImageSrc"
    [width]="width"
    [height]="height"
    alt=""
>
